const shopify = {
  ewalletTip: 'Seleccione su cartera digital abajo: ',
};


module.exports = shopify;
